<template>
  <Payments
    :id="orgId"
    :isProvider="isProvider"
    :productCode="productCode"
    :returnRoute="returnRoute"
    @cancelled="handleCancelled"
    @error="handleError"
    @submitted="handleSubmitted"
    @success="handleSuccess"
  />
</template>
<script>
import {
  ItemTypeConsts,
  StoreModuleMap,
} from 'client/util/Constants';
import { Payments } from '@jumpcloud/ui-payments';
import { eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import { mapActions, mapGetters, mapState } from 'vuex';
import EventHelper from 'client/GrowthEngineering/EventHelper';

const settingsModule = StoreModuleMap[ItemTypeConsts.settings];
const organizationsCollection = 'OrganizationsCollection';
const planModule = 'PlanModule';

const {
  description,
  location,
  section,
  text: textEventProp,
} = eventProperties;

export default {
  name: 'PaymentsWrapper',

  EventHelper,

  components: { Payments },

  props: {
    location: {
      type: String,
      required: true,
    },
    productCode: {
      type: String,
      default: '',
    },
    returnRoute: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapGetters(settingsModule, ['isProvider']),
    ...mapState(settingsModule, ['orgId']),
  },

  methods: {
    ...mapActions(settingsModule, ['fetchSettings']),
    ...mapActions(planModule, ['fetchPlan']),
    ...mapActions(organizationsCollection, ['getDetailsForOrganization']),

    handleCancelled() {
      this.$emit('cancelled');
    },

    handleError(message) {
      this.$emit('error', message);
    },

    handleSubmitted() {
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'submits the billing and credit card information',
        [location]: this.location,
        [section]: 'footer',
        [textEventProp]: 'submit',
      });

      this.$emit('submitted');
    },

    async handleSuccess() {
      this.$emit('success');

      if (!this.isProvider) {
        this.$options.EventHelper.triggerPaymentInfoSubmitted();
      } else {
        this.$options.EventHelper.triggerProviderPaymentInfoSubmitted();
      }

      // Refresh 'isCustomer' and 'hasCreditCard' to keep paywall updated
      await this.fetchSettings();
      // Refresh hasPlan to remove Pricing button from mainHeader
      await this.fetchPlan();
      // Refresh Organization to dismiss banners/notifications
      await this.getDetailsForOrganization({ id: this.orgId });
    },
  },
};
</script>
